// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"be45ebbf","134":"dc0f9db3","141":"b396693d","166":"8dacd596","215":"c1167903","416":"dab8fd87","453":"12b56bc1","504":"cfe26780","584":"c71a6863","597":"c6acd53b","665":"f0c5a402","825":"4edf2dc7","872":"bf2e2569","878":"7f65a521","952":"e04c7f31","963":"37890870"}[chunkId] + ".chunk.js";
};